import type { Condition, EpisodeOfCare } from "@curai/js-fhir-tools";

export enum MedicalHistoryAction {
  RESOLVE = "resolve",
  VOID = "void",
  REACTIVATE = "reactivate",
  CONFIRM = "confirm",
}

export interface AvailableAction {
  action: MedicalHistoryAction;
  unavailableReasons?: string[];
}
export interface MedicalHistory {
  availableActions?: AvailableAction[];
  needsConfirmation?: boolean;
  episodeOfCare: Pick<EpisodeOfCare, "id" | "status" | "meta">;
  condition: Pick<
    Condition,
    "id" | "code" | "note" | "verificationStatus" | "recorder" | "recordedDate"
  >;
  lastVisit: string | null;
}
